import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SpecialOpeningClosingHoursRequest } from '../../../models/api-store/special-opening-closing-hours/special-opening-closing-hours.request.model';
import { FALSE } from '../../../utils/config/const';
import { ConfigIntervalNameLower, intervalsLower } from '../../../utils/config/hours.config';
import { HoursService } from '../../../services/hours/hours.service';

@Component({
  selector: 'app-specialopeninghours',
  templateUrl: './specialopeninghours.component.html'
})
export class SpecialopeninghoursComponent implements OnInit, OnChanges {

  @Input() inputSpecialOpeningHours: SpecialOpeningClosingHoursRequest;
  @Output() outputSpecialOpeningHours = new EventEmitter<any>();
  formBuilder: FormGroup;

  orariMattina: string[];
  orariPomeriggio: string[];
  SpecialOpeninghoursView = {
    mFrom: [],
    mTo: [],
    eFrom: [],
    eTo: []
  };

  constructor(
    private fb: FormBuilder,
    private hoursService: HoursService
  ) {
    this.formBuilder = this.fb.group(new SpecialOpeningClosingHoursRequest(), { updateOn: "change" });
    this.orariMattina = this.hoursService.generateTimeArray(7, 16, 5);
    this.orariPomeriggio = this.hoursService.generateTimeArray(12, 22, 5);
  }

  ngOnInit(): void {
    this.initSpecialOpeninghoursView();
    this.changeValue();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (typeof changes.inputSpecialOpeningHours.currentValue != typeof undefined) {
      this.setValue();
      this.initSpecialOpeninghoursView();
    }
  }

  get form() { return this.formBuilder; }
  get formControls() { return this.formBuilder.controls; }


  setValue() {
    this.inputSpecialOpeningHours = new SpecialOpeningClosingHoursRequest();
    this.formBuilder = this.fb.group(this.inputSpecialOpeningHours, { updateOn: "change" });
  }

  /**
   * Setta i valori del form in output
   * @returns 
   */
  getValue() {
    let specialOpeningHoursRequestUpdate = new SpecialOpeningClosingHoursRequest();
    for (let intervallo of intervalsLower) {
      specialOpeningHoursRequestUpdate[intervallo] = this.formBuilder.controls[intervallo].value;
    }
    specialOpeningHoursRequestUpdate['note'] = this.formBuilder.controls['note'].value;
    specialOpeningHoursRequestUpdate['date'] = this.formBuilder.controls['date'].value;
    return specialOpeningHoursRequestUpdate;
  }

  /**
  * Aggiorna l'output
  */
  changeValue() {
    let output = this.getValue();
    this.outputSpecialOpeningHours.emit({
      output: output,
      status: this.formBuilder.status,
      touched: this.formBuilder.touched
    });
  }



  /**
   * Inizializza i range della view
   */
  initSpecialOpeninghoursView() {
    let startValue = "0";

    //Init range MFrom
    this.SpecialOpeninghoursView[ConfigIntervalNameLower.mFrom] = this.getHoursByHour(startValue, 'M');

    //Init range MTo
    this.SpecialOpeninghoursView[ConfigIntervalNameLower.mTo] = this.getHoursByHour(startValue, 'M');

    //Init range EFrom
    this.SpecialOpeninghoursView[ConfigIntervalNameLower.eFrom] = this.getHoursByHour(startValue, 'E');

    //Init range ETo
    this.SpecialOpeninghoursView[ConfigIntervalNameLower.eTo] = this.getHoursByHour(startValue, 'E');
  }






  /**
   * Controlla se nella riga ci sono problemi ed in caso li segnala
   */
  validateRow() {
    this.validateMFrom();
    this.validateMTo();
    this.validateEFrom();
    this.validateETo();
    this.validateDate();
  }


  validateDate() {
    let isValid = true;
    let valueDate = this.formBuilder.controls['date'].value;
    if (valueDate == "") {
      this.formBuilder.controls['date'].setErrors(['date']);
      isValid = false;
    } else {
      this.formBuilder.controls['date'].setErrors(null);
    }
    return isValid;
  }


  getvalueNameFieldmFromFORM() {
    return this.formBuilder.controls[ConfigIntervalNameLower.mFrom].value;
  }
  getvalueNameFieldmToFORM() {
    return this.formBuilder.controls[ConfigIntervalNameLower.mTo].value;
  }
  getvalueNameFieldeFromFORM() {
    return this.formBuilder.controls[ConfigIntervalNameLower.eFrom].value;
  }
  getvalueNameFieldeToFORM() {
    return this.formBuilder.controls[ConfigIntervalNameLower.eTo].value;
  }


  /**
   * Controllo validità per il campo MFrom
   * @returns 
   */
  isValidateMFrom() {
    let isValid = true;
    let valueNameFieldMFrom = this.getvalueNameFieldmFromFORM();
    let valueNameFieldMTo = this.getvalueNameFieldmToFORM();
    let valueNameFieldEFrom = this.getvalueNameFieldeFromFORM();
    let valueNameFieldETo = this.getvalueNameFieldeToFORM();
  
    // If MFrom is filled
    if (valueNameFieldMFrom !== "") {
      if (valueNameFieldMTo !== "" && this.hourToInt(valueNameFieldMFrom) >= this.hourToInt(valueNameFieldMTo)) {
        isValid = false;
      }
  
      if (valueNameFieldEFrom !== "" && this.hourToInt(valueNameFieldMFrom) >= this.hourToInt(valueNameFieldEFrom)) {
        isValid = false;
      }
  
      if (valueNameFieldETo !== "" && this.hourToInt(valueNameFieldMFrom) > this.hourToInt(valueNameFieldETo)) {
        isValid = false;
      }
    } else {
      if (valueNameFieldMTo !== "" || (valueNameFieldEFrom === "" && valueNameFieldETo !== "")) {
        isValid = false;
      }
    }
  
    return isValid;
  }
  validateMFrom() {
    let isValid = this.isValidateMFrom();
    if (isValid == FALSE) {
      this.formBuilder.controls[ConfigIntervalNameLower.mFrom].setErrors([ConfigIntervalNameLower.mFrom]);
    } else {
      this.formBuilder.controls[ConfigIntervalNameLower.mFrom].setErrors(null);
    }
    return isValid;
  }



  /**
   * Controllo validità per MTo
   * @returns 
   */
  isValidateMTo() {
    let isValid = true;
    let valueNameFieldMFrom = this.getvalueNameFieldmFromFORM();
    let valueNameFieldMTo = this.getvalueNameFieldmToFORM();
    let valueNameFieldEFrom = this.getvalueNameFieldeFromFORM();
    let valueNameFieldETo = this.getvalueNameFieldeToFORM();
  
    // If MTo is filled
    if (valueNameFieldMTo !== "") {
      if (valueNameFieldMFrom !== "" && this.hourToInt(valueNameFieldMTo) <= this.hourToInt(valueNameFieldMFrom)) {
        isValid = false;
      }
  
      if (valueNameFieldEFrom !== "" && this.hourToInt(valueNameFieldMTo) >= this.hourToInt(valueNameFieldEFrom)) {
        isValid = false;
      }
  
      if (valueNameFieldETo !== "" && this.hourToInt(valueNameFieldMTo) > this.hourToInt(valueNameFieldETo)) {
        isValid = false;
      }
    } else {
      if ((valueNameFieldETo === "" && (valueNameFieldMFrom === "" || valueNameFieldEFrom === "")) || (valueNameFieldMFrom !== "" && valueNameFieldEFrom !== "" && valueNameFieldETo !== "")) {
        isValid = false;
      }
    }
  
    return isValid;
  }
  validateMTo() {
    let isValid = this.isValidateMTo();
    if (isValid == FALSE) {
      this.formBuilder.controls[ConfigIntervalNameLower.mTo].setErrors([ConfigIntervalNameLower.mTo]);
    } else {
      this.formBuilder.controls[ConfigIntervalNameLower.mTo].setErrors(null);
    }
    return isValid;
  }




  /**
   * Controllo validità per EFrom
   */
  isValidateEFrom() {
    let isValid = true;
    let valueNameFieldMFrom = this.getvalueNameFieldmFromFORM();
    let valueNameFieldMTo = this.getvalueNameFieldmToFORM();
    let valueNameFieldEFrom = this.getvalueNameFieldeFromFORM();
    let valueNameFieldETo = this.getvalueNameFieldeToFORM();
  
    // If EFrom is filled
    if (valueNameFieldEFrom !== "") {
      if (valueNameFieldMFrom !== "" && this.hourToInt(valueNameFieldEFrom) <= this.hourToInt(valueNameFieldMFrom)) {
        isValid = false;
      }
  
      if (valueNameFieldMTo !== "" && this.hourToInt(valueNameFieldEFrom) <= this.hourToInt(valueNameFieldMTo)) {
        isValid = false;
      }
  
      if (valueNameFieldETo !== "" && this.hourToInt(valueNameFieldEFrom) >= this.hourToInt(valueNameFieldETo)) {
        isValid = false;
      }
    } else {
      if ((valueNameFieldETo === "" && (valueNameFieldMFrom === "" || valueNameFieldMTo === "")) || (valueNameFieldMFrom !== "" && valueNameFieldMTo !== "" && valueNameFieldETo !== "")) {
        isValid = false;
      }
    }
  
    return isValid;
  }
  validateEFrom() {
    let isValid = this.isValidateEFrom();
    if (isValid == FALSE) {
      this.formBuilder.controls[ConfigIntervalNameLower.eFrom].setErrors([ConfigIntervalNameLower.eFrom]);
    } else {
      this.formBuilder.controls[ConfigIntervalNameLower.eFrom].setErrors(null);
    }
    return isValid;
  }




  /**
   * Controllo validità per ETo
   */
  isValidateETo() {
    let isValid = true;
    let valueNameFieldMFrom = this.getvalueNameFieldmFromFORM();
    let valueNameFieldMTo = this.getvalueNameFieldmToFORM();
    let valueNameFieldEFrom = this.getvalueNameFieldeFromFORM();
    let valueNameFieldETo = this.getvalueNameFieldeToFORM();
  
    // If ETo is filled
    if (valueNameFieldETo !== "") {
      if (valueNameFieldMFrom !== "" && this.hourToInt(valueNameFieldETo) <= this.hourToInt(valueNameFieldMFrom)) {
        isValid = false;
      }
  
      if (valueNameFieldMTo !== "" && this.hourToInt(valueNameFieldETo) <= this.hourToInt(valueNameFieldMTo)) {
        isValid = false;
      }
  
      if (valueNameFieldEFrom !== "" && this.hourToInt(valueNameFieldETo) <= this.hourToInt(valueNameFieldEFrom)) {
        isValid = false;
      }
    } else {
      if (valueNameFieldEFrom !== "" || valueNameFieldMFrom === "") {
        isValid = false;
      }
    }
  
    return isValid;
  }
  validateETo() {
    let isValid = this.isValidateETo();
    if (isValid == FALSE) {
      this.formBuilder.controls[ConfigIntervalNameLower.eTo].setErrors([ConfigIntervalNameLower.eTo]);
    } else {
      this.formBuilder.controls[ConfigIntervalNameLower.eTo].setErrors(null);
    }
    return isValid;
  }



  changeDate() {
    this.validateRow();
    this.changeValue();
  }

  /**
   * Azione - quando cambia MFrom controllo e sistemo gli altri campi
   */
  changeMFrom() {

    //Aggiorno MTo
    if (this.getvalueNameFieldmToFORM() != "") {
      if (this.hourToInt(this.getvalueNameFieldmToFORM()) <= this.hourToInt(this.getvalueNameFieldmFromFORM())) {
        this.formBuilder.controls[ConfigIntervalNameLower.mTo].setValue('');
      }
    }
    this.SpecialOpeninghoursView[ConfigIntervalNameLower.mTo] = this.getHoursByHour(this.getvalueNameFieldmFromFORM(), 'M');

    //Aggiorno EFrom
    if (this.getvalueNameFieldeFromFORM() != "") {
      if (this.hourToInt(this.getvalueNameFieldeFromFORM()) <= this.hourToInt(this.getvalueNameFieldmFromFORM())) {
        this.formBuilder.controls[ConfigIntervalNameLower.eFrom].setValue('');
      }
    }
    this.SpecialOpeninghoursView[ConfigIntervalNameLower.eFrom] = this.getHoursByHour(this.getvalueNameFieldmFromFORM(), 'E');

    //Aggiorno ETo
    if (this.getvalueNameFieldeToFORM() != "") {
      if (this.hourToInt(this.getvalueNameFieldeToFORM()) <= this.hourToInt(this.getvalueNameFieldmFromFORM())) {
        this.formBuilder.controls[ConfigIntervalNameLower.eTo].setValue('');
      }
    }
    this.SpecialOpeninghoursView[ConfigIntervalNameLower.eTo] = this.getHoursByHour(this.getvalueNameFieldmFromFORM(), 'E');

    //Valido riga
    this.validateRow();
    this.changeValue();
  }

  /**
   * Azione - quando cambia MTocontrollo e sistemo gli altri campi
   */
  changeMTo() {

    //Aggiorno EFrom
    if (this.getvalueNameFieldeFromFORM() != "") {
      if (parseInt(this.hourToInt(this.getvalueNameFieldeFromFORM())) < parseInt(this.hourToInt(this.getvalueNameFieldmToFORM()))) {
        this.formBuilder.controls[ConfigIntervalNameLower.eFrom].setValue('');
      }
    }
    this.SpecialOpeninghoursView[ConfigIntervalNameLower.eFrom] = this.getHoursByHour(this.getvalueNameFieldmToFORM(), 'E');

    //Aggiorno ETo
    if (this.getvalueNameFieldeToFORM() != "") {
      if (parseInt(this.hourToInt(this.getvalueNameFieldeToFORM())) < parseInt(this.hourToInt(this.getvalueNameFieldmToFORM()))) {
        this.formBuilder.controls[ConfigIntervalNameLower.eTo].setValue('');
      }
    }
    this.SpecialOpeninghoursView[ConfigIntervalNameLower.eTo] = this.getHoursByHour(this.getvalueNameFieldmToFORM(), 'E');

    //Valido riga
    this.validateRow();
    this.changeValue();
  }

  /**
   * Azione - quando cambia EFrom controllo e sistemo gli altri campi
   */
  changeEFrom() {
    //Aggiorno ETo
    if (this.getvalueNameFieldeToFORM() != "") {
      if (parseInt(this.hourToInt(this.getvalueNameFieldeToFORM())) < parseInt(this.hourToInt(this.getvalueNameFieldeFromFORM()))) {
        this.formBuilder.controls[ConfigIntervalNameLower.eTo].setValue('');
      }
    }
    this.SpecialOpeninghoursView[ConfigIntervalNameLower.eTo] = this.getHoursByHour(this.getvalueNameFieldeFromFORM(), 'E');


    //Valido riga
    this.validateRow();
    this.changeValue();
  }


  /**
   * Azione - quando cambia ETo controllo gli altri campi
   * @param dayOfWeek 
   */
  changeETo() {
    //Valido riga
    this.validateRow();
    this.changeValue();
  }


  /**
   * Aggiorna il range di orari da mostrare
   */
  getHoursByHour(startTime, interval) {
    let res = [];
    let orari = [];

    if (startTime != "") {
      startTime = parseInt(this.hourToInt(startTime));
    } else {
      startTime = 0;
    }
    if (interval == "M") {
      orari = this.orariMattina;
    } else {
      orari = this.orariPomeriggio;
    }
    for (let ora of orari) {
      if (startTime < parseInt(this.hourToInt(ora))) {
        res.push(ora);
      }
    }
    return res;
  }


  /**
   * Converte una string hour in int
   * @param val 
   * @returns 
   */
  hourToInt(val) {
    return val.split(':').join('');
  }

}
